import { isGQLErrorOfType, type QueryError } from '@/utils/errors';

export const isNotFound = (error: QueryError | null): boolean => {
  if (!error) {
    return false;
  }
  return Boolean(error && isGQLErrorOfType(error, 'ExperienceNotFound'));
};

/**
 * True when the experience couldn't be loaded because the viewer lacks access —
 * either they're signed out (`NOT_LOGGED_IN`, e.g. following an invite link
 * before authenticating) or signed in without permission (`InvalidPermission`).
 */
export const isAccessDenied = (error: QueryError | null): boolean => {
  if (!error) {
    return false;
  }
  return (
    isGQLErrorOfType(error, 'InvalidPermission') ||
    isGQLErrorOfType(error, 'NotLoggedIn')
  );
};
